export function round(x: number, places: number = 0): number {
	const scale = Math.pow(10, places);
	return Math.round(x * scale) / scale;
}

export function ones(n: number): number[] {
	return new Array(n).fill(1);
}

export function scalarMultiply(x: number, ys: number[]): number[] {
	return ys.map(y => x * y);
}

export function sum(xs: number[]): number {
	return xs.reduce((acc, x) => acc + x);
}

export function min(xs: number[]): number {
	return Math.min(...xs)
}

export function max(xs: number[]): number {
	return Math.max(...xs)
}

export function allEqual(xs: number[], ys: number[]): boolean {
	return xs.every((x, i) => x == ys[i]);
}

